
export const withPreviousDate = (trips) =>
  trips && trips.map( (trip, i)=> ({
    ...trip,
    // TODO change to isNewDay
    isSameDate: trips[i-1] && trips[i-1].date_formatted == trip.date_formatted,
    // prevTrip: trips[i-1]||null
  }) ) || []

const getLastTripTokenId = (state, trips) =>
  trips.length<1
  ? state.starting_after
  : trips[trips.length-1].token_id


const initialState = {
  expandedView: true,
  hasSelectedAll: false,
  totalResultsCount: 0,
  isPopoverVisible:null,
  isRangePickerOpen: false,
  filterValues: {
    range: [],
    purpose: null,
    count: null,
    place_token_id: null
  },
  filter_params: {
    token_ids: [],

  },
  update_params: {
    purpose: null,
    income_source: null
  },
  endOfList: false,
  filters: {
    // uncategorized: true
  },
  starting_after: '86507f85375b496f94af1b95fb417fcb', // last trip id
  purpose: [
    'Work',
    'Personal',
    'Charity',
    'Medical'
  ],
  isFetching: false,
  totals: {
    "total_miles": "0",
    "total_uncategorized_miles": "0",
    "total_trips_deductions": "0"
  },
  currentTrip: {},
  checkboxesVisible: false,
  unclassified: 0

}

export function filtersReducer(state=initialState.filters, action) {
  switch (action.type) {

    case 'APPLY_DATE_FILTER':
      return {
        ...state,
        ...toRangeParams(action.dateRange)
      }

    case 'SELECT_FAVE_PLACE_FILTER':
      return {
        ...state,
        place_token_id: action.placeId
      }

    case 'SELECT_VEHICLE_FILTER':
      return {
        ...state,
        vehicle_id: action.vehicleId
      }

    case 'SELECT_FILTER':
      if (action.filter == 'Unclassified') return {
        ...state,
        uncategorized: true, purpose: null, income_source: null
      }

      if (action.income_sources.includes(action.filter)) return {
        ...state,
        purpose: 'Work', income_source: action.filter, uncategorized: null
      }

      if (action.filter) return {
        ...state,
        purpose: action.filter, income_source: null, uncategorized: null
      }

      if (!action.filter) return {
        ...state,
        purpose: null, income_source: null, uncategorized: null
      }

    case 'CLEAR_ALL_FILTERS':
      return initialState.filters

    default:
      return state
  }

}

export function filterValuesReducer(state=initialState.filterValues, action) {
  switch (action.type) {
    case 'SELECT_FAVE_PLACE_FILTER':
      return {
        ...state,
        place_token_id: action.placeId
      }
    case 'SELECT_VEHICLE_FILTER':
      return {
        ...state,
        vehicle_id: action.vehicleId
      }
    case 'CLEAR_ALL_FILTERS':
      return initialState.filterValues

    case 'APPLY_DATE_FILTER':
      return {
        ...state,
        range: action.dateRange
      }

    case 'SELECT_FILTER':
      return {
        ...state,
        purpose: action.filter
      }

    default:
      return state
  }

}

export function batchReducer(state=initialState.filter_params.token_ids, action) {

  switch (action.type) {
    case 'UNTOGGLE_ALL_TRIPS':
      return initialState.filter_params.token_ids

    case 'TOGGLE_TRIP':
      return state.includes(action.token_id)
        ? state.filter(token_id=>token_id!=action.token_id)
        : [...state, action.token_id]

    case 'TOGGLE_MANY_TRIPS':
      return [
        ...state,
        ...action.tokenIds
      ]


    default:
      return state
  }

}


export default function trips(state=initialState, action) {
  switch (action.type) {
    case "TOGGLE_VIEW":
      return {
        ...state,
        expandedView: !state.expandedView
      }
    case "DECREMENT_UNCLASSIFIED_TRIP_COUNT":
      return {
        ...state,
        unclassified: state.unclassified-action.count,
      }
    case 'SHOW_CHECKBOXES':
      return {
        ...state,
        checkboxesVisible: true
      }
    case 'HIDE_CHECKBOXES':
      return {
        ...state,
        checkboxesVisible: false
      }

    case 'TOGGLE_RANGEPICKER': {
      return {
        ...state,
        isRangePickerOpen: !state.isRangePickerOpen,
        isPopoverVisible: !state.isRangePickerOpen ? true : null
      }
    }

    case 'CLOSE_FILTER_POPOVER': {
      return {
        ...state,
        isPopoverVisible: null,
        isRangePickerOpen: false

      }
    }


    case 'UPDATE_TRIP_BATCH_SUCCESS':
    case 'UPDATE_TRIP_SUCCESS':
    case 'UPDATE_TRIP_ERROR':
    case 'GET_MORE_TRIPS_SUCCESS':
      return {
        ...state,
        isFetching: false
      }

    case 'UPDATE_TRIP_BATCH_REQUEST':
    case 'UPDATE_TRIP_REQUEST':
    case 'GET_MORE_TRIPS_REQUEST':
      return (action.overrideSuccess) ? state : {
        ...state,
        isFetching: true
      }

    case 'UNTOGGLE_ALL_TRIPS':
    case 'TOGGLE_MANY_TRIPS':
    case 'TOGGLE_TRIP':
      return {
        ...state,
        filter_params: {
          token_ids: batchReducer(state.filter_params.token_ids, action)
        }
      }

    case 'SELECT_ALL_FILTERED_TRIPS':
      return {
        ...state,
        hasSelectedAll: true
      }

    case 'UNSELECT_ALL_FILTERED_TRIPS':
      return {
        ...state,
        hasSelectedAll: false
      }

    case 'SELECT_VEHICLE_FILTER':
    case 'SELECT_FAVE_PLACE_FILTER':
    case 'CLEAR_ALL_FILTERS':
    case 'APPLY_DATE_FILTER':
    case 'SELECT_FILTER':
      return {
        ...state,
        filters: filtersReducer(state.filters, action),
        filterValues: filterValuesReducer(state.filterValues, action),
      }

    case 'NO_MORE_TRIPS':
      return {
        ...state,
        isFetching: false,
        endOfList: true
      }
    case 'GET_TRIPS_REQUEST':
      return {
        ...state,
        isFetching: true,
        endOfList: false,
      }

    case 'LOGIN_REQUEST':
    case 'USER_REQUEST':
      return {
        ...state,
        isFetchingTotals: true
      }

    case 'LOGIN_SUCCESS':
    case 'USER_SUCCESS':

      const totals_names = ["total_revenue", "total_expenses" , "total_trips_deductions", "total_standard_method_expenses", "total_standard_method_revenue" , "total_miles", "total_uncategorized_miles" , "total_business_miles" , "total_personal_miles" , "total_medical_miles", "total_charity_miles" , "total_moving_miles" , "total_other_miles" , "total_kms" , "total_uncategorized_kms", "total_business_kms" , "total_personal_kms" , "total_medical_kms" , "total_charity_kms" , "total_moving_kms" , "total_other_kms"]

      var totals = {}
      totals_names.forEach((name)=>{
        totals[name] = action.user[name]
      })

      return {
        ...state,
        isFetching: false,
        isFetchingTotals: false,
        totals: totals,
        unclassified: action.user.total_uncategorized_trips_count
      }

    case 'GET_TOTALS_REQUEST':
      return {
        ...state,
        totals: {},
        isFetchingTotals: true
      }

    case 'GET_TOTALS_SUCCESS':
      return {
        ...state,
        totals: action.user.totals,
        isFetchingTotals: false
      }

    case 'REMOVE_TRIP':
      return {
        ...state,
        totalResultsCount: state.totalResultsCount-1
      }

    case 'GET_TRIPS_SUCCESS':
      const firstTrip =  action.user.trips[0]
      return {
        ...state,
        isFetching: false,
        totalResultsCount: firstTrip && firstTrip.total_results_count
      }

    // // a single trip
    case 'GET_TRIP_REQUEST':
      return {
        ...state,
        isFetching: true,
        currentTrip: {}
      }
    case 'GET_TRIP_SUCCESS':
      return {
        ...state,
        isFetching: false,
        currentTrip: action.trip
      }

    default:
      return state
  }
}


// TODO same as in /work-hours

export const toRangeParams = (range) => {
  if (range.length<2) return {
    start_day: null,
    start_month: null,
    start_year: null,

    end_day: null,
    end_month: null,
    end_year: null,
  }

  const start = range[0]
  const end = range[1]
  return {
    start_day: start.format("D"),
    start_month: start.format("M"),
    start_year: start.format("YYYY"),

    end_day: end.format("D"),
    end_month: end.format("M"),
    end_year: end.format("YYYY"),
  }
}

// SELECTORS

export const getTripById = (state, id) => state.models.trips.find(trip=> trip.token_id == id )

export const getPurposes = (state) => [
  // INCOME SOURCES:
  "Work", "Personal", ...state.models.user.income_sources,
  // PURPOSES AND CUSTOM PURPOSES:
  "Charity", "Medical", "Moving", "Commute", ...state.models.user.custom_purposes||[]
]

export const calculateDeduction = (irs_mileage_rates={}, work_mileage_rate=0.535, miles=5.3, purpose="Work", year='2017') => {
    if (purpose == 'Work') return work_mileage_rate * miles

    if ( Object.keys(irs_mileage_rates).includes(year) && Object.keys(irs_mileage_rates[year]).includes(purpose) ) {
      return irs_mileage_rates[year][purpose] * miles
    }
    // else
    return 0
}

export const getFilterCount = ({range, ...rest}, count=0) => {
  if (range && range.length>1) count+=1
  Object.keys(rest).forEach(key => rest[key] ? count+=1 : null)
  return count
}



// WEBPACK FOOTER //
// ./src/trips/reducer.js